import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import { Editor } from '@tinymce/tinymce-react';

import {
  GetSingleMading,
  reset,
} from "../../../features/mading/MadingSlice";

import { Card, Button, Form, Col, Row } from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import BASE_URL from "../../../api";
import { UserContext } from "../../../utils/ProtectedRoute";

const TINYMCE_API = `${process.env.REACT_APP_TINYMCE_API}`;

const FormMadingPage = () => {
  const [dataMading, setDataMading] = useState({});

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.mading);

  const param = useLocation();
  const navigate = useNavigate();
  const { slug } = useParams();
  const token = localStorage.getItem("token");

  // on init (call once when the page has been loaded)
  useEffect(() => {
    // call api to fetch fakultas dropdown data
    dispatch(reset());
    if (slug) {
      dispatch(GetSingleMading({ slug, token }));
    }
  }, [slug, dispatch, token]);

  // init the model before send to Server, if any.
  // update the model if user role is meant for "MAHASISWA".
  useEffect(() => {
    const copyData = Object.assign(
      { ...data?.data },
      {
        contentInit: data?.data?.content || "",
      }
    );
    setDataMading(copyData);
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: slug ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        slug ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: slug ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (slug) {
            response = await axios.put(
              `${BASE_URL}mading/update/${slug}`,
              {
                ...dataMading,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}mading`,
              {
                ...dataMading,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate("/mading/list");
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        {param.pathname.split("/")[2] === "detail" ? (
          <>
            <div className="d-block mb-4 mb-xl-0">
              <Header title="Detail Mading" />
            </div>
          </>
        ) : param.pathname.split("/")[2] === "create" ? (
          <>
            <div className="d-block mb-4 mb-xl-0">
              <Header title="Buat Mading" />
            </div>
          </>
        ) : param.pathname.split("/")[2] === "edit" ? (
          <>
            <div className="d-block mb-4 mb-xl-0">
              <Header title="Edit Mading" />
            </div>
          </>
        ) : null}
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          dataMading={dataMading}
          setDataMading={setDataMading}
          handleSubmit={handleSubmit}
          formDisable={param.pathname.split("/")[2] === "detail" ? true : false}
          isLoading={isLoading}
          isError={isError}
          slug={slug}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = (props) => {
  const {
    isLoading,
    isError,
    dataMading,
    setDataMading,
    slug,
    handleSubmit,
    formDisable,
  } = props;
  
  const token = localStorage.getItem("token");

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            {isError ? "something error" : null}
            <Col md={12} className="mb-3">
              <Form.Group id="title">
                <Form.Label>Judul</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="masukkan judul mading"
                  name="title"
                  disabled={formDisable}
                  value={dataMading.title || ""}
                  onChange={(e) =>
                    setDataMading({
                      ...dataMading,
                      title: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="content">
                <Form.Label>Isi</Form.Label>
                <Editor
                  apiKey={TINYMCE_API}
                  onEditorChange={(content, editor) => setDataMading({
                    ...dataMading,
                    content: content,
                  })}
                  init={{
                    height: 500,
                    menubar: false,
                    tinycomments_mode: 'embedded',
                    plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                    toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                  }}
                  initialValue={dataMading.contentInit || ""}
                />
              </Form.Group>
            </Col>
            {formDisable && dataMading ? (
              <Col md={12} className="mb-3">
                <Form.Group id="status">
                  <Form.Label>Status</Form.Label>
                  <Form.Check
                    type="checkbox"
                    checked={dataMading.status == 1}
                    label={dataMading.status == 1 ? "AKTIF" : "NONAKTIF"}
                    onChange={(evt) => {
                      evt.preventDefault();
                      const isChecked = evt.target.checked;
                      showAlertDialog({
                        title:"Update Status?",
                        msg: `apakah anda yakin ingin mengupdate data ini?`,
                        confirmButtonText: "Update",
                        onConfirm: async () => {
                          showLoadingDialog();
                          try {
                            const response = await axios.put(
                              `${BASE_URL}mading/update_status/${slug}`,
                              {
                                status: isChecked ? "1" : "0",
                              },
                              {
                                headers: {
                                  Authorization: token,
                                },
                              }
                            );
                            console.log("RESPONSE : ", response);
                            hideLoadingDialog();
                            setDataMading({
                              ...dataMading,
                              status: isChecked ? "1" : "0",
                            })
                          } catch (error) {
                            console.log("ERROR", error);
                            hideLoadingDialog();
                            showFailedDialog({
                              title: "Oops!",
                              msg: error?.response?.data?.message || "Gagal menyimpan data!",
                            });
                          }
                        },
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable && dataMading.nama_user_buat ? (
              <Col md={12} className="mb-3">
                <Form.Group id="nama_user_buat">
                  <Form.Label>Nama User Buat</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="nama_user_buat"
                    disabled={true}
                    value={dataMading.nama_user_buat}
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable && dataMading.created_at ? (
              <Col md={12} className="mb-3">
                <Form.Group id="created_at">
                  <Form.Label>Tanggal Dibuat</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="created_at"
                    disabled={true}
                    value={moment(dataMading.created_at).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                  />
                </Form.Group>
              </Col>
            ) : null}
          </Row>
          {formDisable ? null : (
            <div>
              {slug ? (
                <Button type="submit" disabled={isLoading}>
                  Update
                </Button>
              ) : (
                <Button type="submit" disabled={isLoading}>
                  Simpan
                </Button>
              )}
            </div>
          )}
        </Form>
      )}
    </Card.Body>
  );
};

export default FormMadingPage;
